// eslint-disable-next-line no-unused-vars
import * as types from '@/store/types'
export default {
    messageRating: state => {
        return state.messageRating
    },
    messagesSendInfoOutput: state => {
        return state.messagesSendInfo.output
    },
    messagesSendInfoInput: state => {
        return state.messagesSendInfo.input
    },
    messagesSendInfoMailing: state => {
        return state.messagesSendInfo.mailing
    },
    messagesSendInfoLabels: state => {
        return state.messagesSendInfo.labels
    },
    getClientsInfoSubscribe: state => {
        return state.clientsInfo.subscribe
    },
    getClientsInfoUnsubscribe: state => {
        return state.clientsInfo.unsubscribe
    },
    getClientsInfoLabels: state => {
        return state.clientsInfo.labels
    },
    modelDefault: state => {
        return state.modelDefault
    },
    loaded: state => {
        return state.loaded
    },
    loadedMessagesOutput: state => {
        return state.loadedMessagesOutput
    },
    loadedMessagesInput: state => {
        return state.loadedMessagesInput
    },
    loadedMessagesMailing: state => {
        return state.loadedMessagesMailing
    },
    loadedClientsSubscribe: state => {
        return state.loadedClientsSubscribe
    },
    loadedClientsUnsubscribe: state => {
        return state.loadedClientsUnsubscribe
    },
    messagesToday: state => {
        return state.messagesToday
    },
    clientsToday: state => {
        return state.clientsToday
    }
}
